import formatDate from 'date-fns/format';
import i18n from '../../i18n';

const formats = {
  'pt-BR': 'DD/MM/YYYY HH:mm:ss',
  en: 'MM/DD/YYYY HH:mm:ss',
  es: 'DD/MM/YYYY HH:mm:ss',
};


const activeFormat = formats[i18n.locale];

const formatedDate = (date) => formatDate(date, activeFormat);

export default formatedDate;



/** WEBPACK FOOTER **
 ** ./src/helpers/date/index.js
 **/